module.exports = __webpack_public_path__ + "static/media/optibolt-3.ce101fad.jpg";